import React from 'react'
import ParadigmaTable from '../../../components/ParadigmaTable/ParadigmaTable'
import api from '../../../api/api'

const TableCambiosVencimiento = () => {
  
  const columns = [
    {
      Header: "Fecha",
      id: "fecha",
      width: 170,
      className: 'text-center',
      accessor: d => d.fecha ? d.fecha.split('T')[0] : '',
      show: true,
    },
    {
      Header: "Fecha Anterior",
      id: "old",
      width: 170,
      className: 'text-center',
      accessor: d => d.old ? d.old.split('T')[0] : '', 
      show: true,
    },
    {
      Header: "Fecha Nueva",
      id: "new",
      width: 170,
      className: 'text-center',
      accessor: d => d.new ? d.new.split('T')[0] : '',
      show: true,
    },
    {
      Header: "Motivo",
      id: "motivo",
      accessor: "motivo", 
      show: true,
    },
    {
      Header: "Usuario",
      id: "user",
      width: 400,
      accessor: d => d.user ? `${d.user.last_name}, ${d.user.first_name}` : '',
      show: true,
    },
]

  return (
    <ParadigmaTable
      buttons={[]}
      apiUrl={api.configuracion.vencimientoList}
      depth={2}
      columns={columns}
      exportUrl={api.configuracion.vencimientoList}
      title={"Registro de cambios de fechas de vencimiento."}
    >
    </ParadigmaTable>
  )
}

export default TableCambiosVencimiento


// WEBPACK FOOTER //
// ./src/views/Configuracion/CambiarVencimiento/TableCambiosVencimiento.js